import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { configureDataGridColumnsOrder } from "@/common/util";
import { RateItem } from "@/services/entities/RateItem";
import DxDataGrid, {
    DxColumn,
    DxFilterRow,
    DxPaging, DxPager,
    DxStateStoring,
    DxHeaderFilter,
    DxButton
} from "devextreme-vue/data-grid";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RateTable',
  props: {
    data: { Type: [] as RateItem[], default: [] as RateItem[] },
},
  emits: ["edit", "delete"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selectedKeys = ref([] as number[]);
let isConfigured = false;

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['name', 'description', 'value', 'currency', 'disabled' , 'buttons'];
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }
};

const props = __props;

function edit(item: any) {
    selectedKeys.value = [item.row.data.id];
    emit("edit", item.row.data.id);
}

function deleteRate(item: any) {
    emit("delete", item.row.data.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    id: "rateGridContainer",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id",
    onContentReady: onContentReady
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "rateGridContainer"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "ID",
        visible: false
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "name",
        "data-type": "string",
        caption: "Name",
        width: "150"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "description",
        "data-type": "string",
        caption: "Description",
        width: "215"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "value",
        "data-type": "number",
        caption: "Value",
        width: "100"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "currency",
        "data-type": "string",
        caption: "Currency",
        width: "100"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "disabled",
        "calculate-cell-value": row => !row.disabled,
        "data-type": "boolean",
        caption: "Active",
        width: "95"
      }, null, 8, ["calculate-cell-value"]),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 80
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "Edit rate",
            icon: "edit",
            "styling-mode": "contained",
            type: "normal",
            onClick: edit
          }),
          _createVNode(_unref(DxButton), {
            hint: "Delete rate",
            icon: "trash",
            "styling-mode": "contained",
            type: "normal",
            onClick: deleteRate
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})